import useManifestPrintout from "../../../scheduling/Printout/useManifestPrintout";

function processPax(pax: any) {
    return {
        lastName: pax?.lastName,
        firstName: pax?.firstName,
        employerName: pax?.employerID?.name,
        checkedInTime: pax?.checkedInTime,
        paxWeight: pax?.paxWeight,
        bagWeight: pax?.bagWeight,
        departureName: pax?.departureID?.name,
        destinationName: pax?.destinationID?.name,
        chargeCode: pax?.chargeCode,
        transitType: pax?.transitType,
    };
}

function processCgo(cgo: any) {
    return {
        name: cgo?.name,
        weight: cgo?.weight,
        departureName: cgo?.departureID?.name,
        destinationName: cgo?.destinationID?.name,
        chargeCode: cgo?.chargeCode,
        transitType: cgo?.transitType,
    };
}

function processFlight(flight: any) {
    let pilotNameParts: string[] = [];
    if (flight.pilot) {
        const lName = flight.pilot?.name?.lastName;
        const fName = flight.pilot?.name?.firstName;
        if (lName) pilotNameParts.push(lName);
        if (fName) pilotNameParts.push(fName);
    }
    const pilotName = pilotNameParts.join(", ");

    let routeNames: any[] = [];
    if (flight.legsArray && flight.legsArray["0"] && flight.legsArray["0"].departure) {
        routeNames.push(flight.legsArray["0"].departure);
        for (const index in flight.legsArray) {
            if (Object.prototype.hasOwnProperty.call(flight.legsArray, index)) {
                routeNames.push(flight.legsArray[index]?.destination || "null");
            }
        }
    }

    return {
        name: flight.desig || flight.name,
        pilotName,
        tailNum: flight.aircraftID?.tailNum,
        scheduledFlightDate: flight.scheduledFlightDate,
        paxList: (flight.paxIDList || []).map(processPax),
        cgoList: (flight.cgoIDList || []).map(processCgo),
        routeNames,
    };
}

export function useTalosFlightPrintout(props: { flight: any }){
    const [ fetchPrintout, fetching ] = useManifestPrintout('MultiFlightManifest', 'Talos');

    const flightData = props.flight ? processFlight(props.flight) : null;

    const inputData = {
        flights: flightData ? [flightData] : []
    };

    return {
        download: () => fetchPrintout(inputData, true),
        loading: fetching
    }
}